import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})

export class SessionStorageUtil {

    constructor(@Inject(DOCUMENT) private document: Document) {}

    // Método para guardar variable en sessionStorage
    save(clave: string, valor: string): void {
        sessionStorage.setItem(clave, valor);
    }

    // Método para eliminar variable en sessionStorage
    delete(clave: string): void {
        sessionStorage.removeItem(clave);
    }

    // Método para obtener el valor de una variable en sessionStorage
    get(clave: string): string | null {
        return sessionStorage.getItem(clave);
    }

     // Método para verificar si existe la cookie
    check(clave: string): boolean {
        return sessionStorage.getItem(clave) !== null;
    }

}